import { createContext, useEffect, useState } from 'react';
import NRRemediationModal from './NRRemediationModal/NRRemediationModal';

export const RemediationContext = createContext({
  openRemediationModal: null,
  setOpenRemediationModal: () => {},
  showUnremediated: null,
  setShowUnremediated: () => {},
  CVEs: null,
  setCVEs: () => {},
  content: null,
  setContent: () => {},
  title: null,
  setTitle: () => {},
  vulnerabilities: null,
  setVulnerabilities: () => {},
  lastQueryVariables: null,
  setLastQueryVariables: () => {},
  lastQueryLicenseIssuesVariables: null,
  setLastQueryLicenseIssuesVariables: () => {},
  remediateAllVulnerabilitiesFilter: null,
  setRemediateAllVulnerabilitiesFilter: () => {}
});

function NRRemediationContextWrapper({ children }) {
  const [openRemediationModal, setOpenRemediationModal] = useState(false);
  const [showUnremediated, setShowUnremediated] = useState(false);
  const [CVEs, setCVEs] = useState([]);
  const [content, setContent] = useState(null);
  const [title, setTitle] = useState(null);
  const [vulnerabilities, setVulnerabilities] = useState([]);
  const [lastQueryVariables, setLastQueryVariables] = useState({});
  const [lastQueryLicenseIssuesVariables, setLastQueryLicenseIssuesVariables] = useState({});
  const [remediateAllVulnerabilitiesFilter, setRemediateAllVulnerabilitiesFilter] = useState();

  useEffect(() => {
    if (!openRemediationModal) {
      setCVEs([]);
    }
  }, [openRemediationModal]);

  const defaultValues = {
    openRemediationModal,
    setOpenRemediationModal,
    showUnremediated,
    setShowUnremediated,
    CVEs,
    setCVEs,
    vulnerabilities,
    setVulnerabilities,
    lastQueryVariables,
    setLastQueryVariables,
    remediateAllVulnerabilitiesFilter,
    setRemediateAllVulnerabilitiesFilter,
    content,
    setContent,
    title,
    setTitle,
    lastQueryLicenseIssuesVariables,
    setLastQueryLicenseIssuesVariables
  };

  return (
    <RemediationContext.Provider value={defaultValues}>
      <NRRemediationModal />
      {children}
    </RemediationContext.Provider>
  );
}

export default NRRemediationContextWrapper;
